<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_testimonial_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">{{ "testimonial_row_items" | translate }}</label>
                <div class="col-xs-12">
                    <div class="btn-group d-flex">
                        <button
                            *ngFor="let num of MAX_TESTIMONIALS_IN_ROW"
                            [ngClass]="{ active: rowItems.value === num }"
                            (click)="setRowItems(num)"
                            class="btn btn-grey w-100"
                        >
                            {{ num }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-6 control-label">{{ "testimonial_spase_between" | translate }}</label>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/websites/lpc-indent-between-icon.svg"
                        suffixText="px"
                        [min]="0"
                        [max]="50"
                        [value]="spaceBetween.value"
                        (valueChange)="setSpaceBetween($event)"
                    >
                    </sp-input-num>
                </div>
            </div>

            <div
                class="form-group"
                *ngIf="testimonialLayout === ETestimonialLayout.grid"
                [ngClass]="{ 'mb-0': !isShowMore.value, 'mb-20': isShowMore.value }"
            >
                <label class="col-xs-9 control-label"> {{ "testimonial_show_more" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="isShowMore"></sp-switch>
                </div>
            </div>

            <div class="form-group mb-0" *ngIf="testimonialLayout === ETestimonialLayout.grid && isShowMore.value">
                <label class="col-xs-12">
                    {{ "testimonial_button" | translate }}
                </label>
                <div class="col-xs-12">
                    <sp-control-handle
                        [controlHandleMainText]="buttonText"
                        (editActionEvent)="setButtonSettingsOption()"
                    >
                    </sp-control-handle>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="testimonialLayout === ETestimonialLayout.carousel">
                <label class="col-xs-10 control-label">{{ "testimonial_buttons_color" | translate }}</label>
                <div class="col-xs-2">
                    <sp-color-picker
                        [colorsPreset]="selectedThemeColors()"
                        [color]="buttonColor.value"
                        (colorChangeEvent)="setButtonColor($event)"
                    ></sp-color-picker>
                </div>
            </div>

            <div *ngIf="testimonialLayout === ETestimonialLayout.carousel" class="form-group mb-0">
                <label class="col-xs-9 control-label"> {{ "testimonial_autoscroll" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="isAutoScroll" (toggleActiveEvent)="setAutoScroll($event)"></sp-switch>
                </div>
            </div>

            <div class="form-group mb-0">
                <hr class="panel-options-divider" />
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12"> {{ "testimonial_type" | translate }} </label>
                <div class="col-xs-12">
                    <div class="appearance-wrapper">
                        <div
                            class="appearance-block collage"
                            *ngFor="let el of TESTIMONIALS_TYPES"
                            [ngClass]="{ active: type.value === el.type }"
                            (click)="setTestimonialType(el.type)"
                        >
                            <img
                                src="./assets/img/websites/testimonial-variants/lpc-testimonial-{{ el.label }}.svg"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group" [ngClass]="{ 'mb-0': !isShortText.value, 'mb-20': isShortText.value }">
                <label class="col-xs-9 control-label"> {{ "testimonial_show_short_text" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="isShortText"></sp-switch>
                </div>
            </div>

            <div class="form-group mb-0" *ngIf="isShortText.value">
                <label class="col-xs-12">{{ "testimonial_link_text_color" | translate }}</label>
                <div class="col-xs-10">
                    <input class="form-control" [formControl]="linkText" />
                </div>
                <div class="col-xs-2">
                    <sp-color-picker
                        [hideGradient]="true"
                        [colorsPreset]="selectedThemeColors()"
                        [color]="linkColor.value"
                        (colorChangeEvent)="setLinkColor($event)"
                    ></sp-color-picker>
                </div>
            </div>

            <div class="form-group mb-0">
                <hr class="panel-options-divider" />
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_text_style" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="fontSize.value"
                        (valueChange)="setFontSize($event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="fontStyle.value === EFontStyle.AT"
                            (click)="setFontStyle(EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="fontStyle.value === EFontStyle.B"
                            (click)="setFontStyle(EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="fontStyle.value === EFontStyle.I"
                            (click)="setFontStyle(EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <sp-color-picker
                        [hideGradient]="true"
                        [colorsPreset]="selectedThemeColors()"
                        [color]="fontColor.value"
                        (colorChangeEvent)="setFontColor($event)"
                    ></sp-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-10 control-label">{{ "control_background_color" | translate }}</label>
                <div class="col-xs-2">
                    <sp-color-picker
                        [colorsPreset]="selectedThemeColors()"
                        [color]="backgroundColor.value"
                        (colorChangeEvent)="setBackgroundColor($event)"
                    ></sp-color-picker>
                </div>
            </div>

            <div class="form-group">
                <label class="col-xs-9 control-label"> {{ "control_contour" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="isBorder"></sp-switch>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="isBorder.value">
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [min]="SIZE_MIN"
                        [max]="SIZE_MAX"
                        [value]="borderWidth.value"
                        (valueChange)="setBorderWidth($event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <select class="form-control" [formControl]="borderStyle">
                        <option [ngValue]="lineStyle.SOLID">{{ "control_solid" | translate }}</option>
                        <option [ngValue]="lineStyle.DASHED">{{ "control_dashed" | translate }}</option>
                        <option [ngValue]="lineStyle.DOTTED">{{ "control_dotted" | translate }}</option>
                    </select>
                </div>
                <div class="col-xs-2">
                    <sp-color-picker
                        [color]="borderColor.value"
                        [hideGradient]="true"
                        [colorsPreset]="selectedThemeColors()"
                        (colorChangeEvent)="setBorderColor($event)"
                    ></sp-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-9 control-label"> {{ "control_shadow" | translate }} </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [control]="isShadow"></sp-switch>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-6 control-label">
                    {{ "control_radius" | translate }}
                </label>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="rounding.value"
                        (valueChange)="setRounding($event)"
                        (blurEvent)="setRounding($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div class="form-group mb-10">
                <label class="col-xs-6">
                    {{ "control_padding" | translate }}
                </label>
                <div class="col-xs-6 text-right">
                    <div class="preset-padding-buttons">
                        <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">0</button>
                        <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(15)">15</button>
                        <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(30)">30</button>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-xs-12 d-flex">
                    <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                        <sp-input-num
                            suffixText="px"
                            [min]="SIZE_MIN"
                            [max]="SIZE_MAX"
                            [value]="paddingLeft.value"
                            (valueChange)="setPaddingLeft($event)"
                        ></sp-input-num>
                    </div>
                    <div style="flex-grow: 1">
                        <div class="mb-10">
                            <sp-input-num
                                suffixText="px"
                                [min]="SIZE_MIN"
                                [max]="SIZE_MAX"
                                [value]="paddingTop.value"
                                (valueChange)="setPaddingTop($event)"
                            ></sp-input-num>
                        </div>
                        <sp-input-num
                            suffixText="px"
                            [min]="SIZE_MIN"
                            [max]="SIZE_MAX"
                            [value]="paddingBottom.value"
                            (valueChange)="setPaddingBottom($event)"
                        ></sp-input-num>
                    </div>
                    <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                        <sp-input-num
                            suffixText="px"
                            [min]="SIZE_MIN"
                            [max]="SIZE_MAX"
                            [value]="paddingRight.value"
                            (valueChange)="setPaddingRight($event)"
                        ></sp-input-num>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
